export default __webpack_public_path__ + "media/images/6-ad390a429e4a1a2f2051fdfa8702d63b.jpg";